import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// project imports
import Loadable from 'ui-component/Loadable';
import MinimalLayout from 'layout/MinimalLayout';

// login option 3 routing
const LoginCognito = Loadable(lazy(() => import('views/pages/authentication/authentication3/LoginCognito')));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = ({ authStatus }) => {
  return {
    path: '/',
    element: <MinimalLayout />,
    children: [
      {
        path: 'login',
        element: authStatus !== 'configuring' && authStatus === 'authenticated' ? <Navigate replace to="/logs/history" /> : <LoginCognito />
      }
    ]
  };
};

export default AuthenticationRoutes;
